export default "__VITE_ASSET__6531a7a3__"